import { Dropdown as AntdDropdown, type DropdownProps } from 'antd';
import { memo, useCallback } from 'react';
import styled from 'styled-components';
import useCompanyColorLuminance from '../utilities/useCompanyColorLuminance';

export const DropdownContainer = styled.div<{ luminance: number }>`
    max-height: 80vh;
    overflow-y: scroll;
    padding: 0px;
    box-shadow:
        rgba(0, 0, 0, 0.05) 0px 0.125rem 0.25rem 0px,
        rgba(0, 0, 0, 0.2) 0px 0.9375rem 1.25rem 0px;

    &::-webkit-scrollbar {
        display: none;
    }

    & .ant-dropdown-menu-item-selected,
    .ant-dropdown-menu-submenu-title-selected {
        color: ${props => (props.luminance < 0.5 ? '#fff' : '#000')};
        background-color: var(--ant-primary-color);
    }

    & .ant-dropdown-menu-item:hover {
        background-color: #f5f5f5;
        color: var(--ant-primary-color);
    }
`;

const Dropdown = ({ dropdownRender: dropdownRenderProp, ...props }: DropdownProps) => {
    const luminance = useCompanyColorLuminance();
    const dropdownRender = useCallback(
        (menu: React.ReactElement) => (
            <DropdownContainer luminance={luminance}>
                {dropdownRenderProp ? dropdownRenderProp(menu) : menu}
            </DropdownContainer>
        ),
        [dropdownRenderProp, luminance]
    );

    return <AntdDropdown dropdownRender={dropdownRender} {...props} />;
};

export default memo(Dropdown);
